import * as React from 'react';

interface OnboardingWizardContainerProps {
  children: React.ReactNode;
}

export const OnboardingWizardContainer: React.FC<
  OnboardingWizardContainerProps
> = ({ children }): React.ReactElement => (
  <div className='relative min-h-screen'>{children}</div>
);
